import { StandardEvents } from '@shopify/events';

class JbgInventoryStatus extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#request++;
  }

  #update = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const next = detail.html.querySelector(
        `jbg-inventory-status[data-block-id="${CSS.escape(this.dataset.blockId)}"]`
      );
      if (!next) return;
      this.dataset.productId = next.dataset.productId;
      this.replaceChildren(...Array.from(next.childNodes, (node) => node.cloneNode(true)));
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[jbg-inventory-status]', error);
    }
  };
}

if (!customElements.get('jbg-inventory-status')) {
  customElements.define('jbg-inventory-status', JbgInventoryStatus);
}
